$(document).on('ready turbolinks:load', () => {
  $('.row-link[data-href] td:not(.not-a-link)').off('click').on('click', ({ currentTarget }) => {
    const $row = $(currentTarget).parent();
    switch ($row.data('method')) {
      case 'visit':
        return Turbolinks.visit($row.data('href'));
      case 'remote':
        return $.getScript($row.data('href'));
      default:
        return console.warn('unidentified row link method'); // eslint-disable-line
    }
  });
});
